import { TransformWrapper } from '../../../modules/design/transforms/transform.wrapper';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { Datatype } from 'src/app/shared/databases/datatype';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { ObjectWrapperUtil } from 'src/app/shared/utils/object.wrapper.util';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Util } from 'src/app/shared/utils/util';
import { Business_GlossaryUtil } from './business_glossary.util';
import { ObjectUtil } from 'src/app/shared/utils/object.util';
import { DatabaseWrappersFactory } from 'src/app/shared/databases/database.wrappers.factory';
import { CarryForwardAttribute } from 'src/app/shared/beans/carryforwardattribute';
import { Attribute } from 'src/app/shared/models/domain/attribute';
import { DIMsgObj } from 'src/app/shared/models/dimsgobj';
import { ClipboardCache } from '../../caches/clipboard.cache';
import { Repository } from 'src/app/modules/repository/repository';
import { TransformsUtil } from 'src/app/modules/design/transforms/transforms.util';

export class Business_GlossaryGridUtil {
    private static instance: Business_GlossaryGridUtil;
    business_glossaryUtil: Business_GlossaryUtil;

    static getInstance() {
        if (!Business_GlossaryGridUtil.instance) {
            Business_GlossaryGridUtil.instance = new Business_GlossaryGridUtil();
        }

        return Business_GlossaryGridUtil.instance;
    }

    util: Util;
    business_glossary: Business_GlossaryUtil;
    objectWrapperUtil: ObjectWrapperUtil;
    databaseWrappersFactory: DatabaseWrappersFactory;
    clipboardCache: ClipboardCache;

    /**
      * AttributesGridUtil is a singleton class, so use AttributesGridUtil.getInstance() method instead of creating new AttributesGridUtil().
      */
    private constructor() {
        this.util = Util.getInstance();
        this.business_glossaryUtil = Business_GlossaryUtil.getInstance();
        this.objectWrapperUtil = ObjectWrapperUtil.getInstance();
        this.databaseWrappersFactory = DatabaseWrappersFactory.getInstance();
        this.clipboardCache = ClipboardCache.getInstance();
    }

    get(attr_Id: number, attributes: Array<Attribute>): Attribute {
        for (let i = 0; i < attributes.length; i++) {
            if (attributes[i].attr_Id == attr_Id)
                return attributes[i];
        }

        return null;
    }

    removeByIndices(indices: Array<number>, attributes: Array<Attribute>): Array<Attribute> {
        let deletedAttributes: Array<Attribute> = new Array<Attribute>();

        for (let i: number = indices.length - 1; i >= 0; i--) {
            let index: number = indices[i];
            let splicedAttributes: Array<Attribute> = attributes.splice(index, 1);
            deletedAttributes.push(splicedAttributes[0]);
        }

        return deletedAttributes;
    }

    add(selectedIndex: number, attributes: Array<Attribute>, objectWrapper: ObjectWrapper, attrType_Cd: string): DIMsgObj {
        let diMsgObj: DIMsgObj = new DIMsgObj();

        let attribute: Attribute = this.business_glossaryUtil.getNewAttribute(objectWrapper, attrType_Cd, -1);

        attribute.attrType_Cd = attrType_Cd;
        attribute.srt_Order = selectedIndex;
        attribute.valid_Cd = "0";
        attribute.error_Msg = this.objectWrapperUtil.getError_Msg(attribute.valid_Cd);

        if (objectWrapper.dbTyp_Id == DatabaseEnum.cobol.ID) {
            let cLevels: Array<number> = this.business_glossaryUtil.getCLevels(attributes);

            if (cLevels.length > 0)
                attribute.clevel = cLevels[0];
        }

        if (attrType_Cd == CommonEnums.attrType_Cd.DERIVED_ATTRIBUTE) {
            attribute.attrType_Cd = CommonEnums.attrType_Cd.DERIVED_ATTRIBUTE;
            attribute.valid_Cd = 'EMPT_COND';
            attribute.error_Msg = this.objectWrapperUtil.getError_Msg(attribute.valid_Cd);
        }

        this.business_glossaryUtil.insert(attribute, attributes, objectWrapper, selectedIndex);
        objectWrapper.doValidate();

        diMsgObj.retMsgObject = attribute

        return diMsgObj;
    }

    addRecord(selectedIndex: number, attributes: Array<Attribute>, objectWrapper: ObjectWrapper, attrType_Cd: string): DIMsgObj {
        let diMsgObj: DIMsgObj = new DIMsgObj();

        let attribute: Attribute = this.business_glossaryUtil.getNewAttributeForRecord(objectWrapper, attrType_Cd, -1, attributes);

        attribute.attrType_Cd = attrType_Cd;
        attribute.srt_Order = 0;
        attribute.valid_Cd = "0";
        attribute.error_Msg = this.objectWrapperUtil.getError_Msg(attribute.valid_Cd);

        if (objectWrapper.dbTyp_Id == DatabaseEnum.cobol.ID) {
            let cLevels: Array<number> = this.business_glossaryUtil.getCLevels(attributes);

            if (cLevels.length > 0)
                attribute.clevel = cLevels[0];
        }

        attribute.hiddenFlg = 'Y';

        this.business_glossaryUtil.insert(attribute, attributes, objectWrapper, selectedIndex);
        objectWrapper.doValidate();

        diMsgObj.retMsgObject = attribute

        return diMsgObj;
    }

    attrDTyp_IdChanged(attribute: Attribute, attributes: Array<Attribute>,
        objectWrapper: ObjectWrapper, oldAttrDTyp_Id: number): void {

        let nativeDbTyp_Id: number = objectWrapper.nativeDbTyp_Id == -2 ? objectWrapper.dbTyp_Id : objectWrapper.nativeDbTyp_Id;

        let datatype: Datatype = this.databaseWrappersFactory.getDatatype(nativeDbTyp_Id, attribute.attrDTyp_Id);
        if (!datatype) return;

        attribute.attrPrec = datatype.defaultprecision;
        attribute.attrScale = datatype.defaultscale;

        if (datatype.hasOwnProperty('minprec') &&
            datatype.hasOwnProperty('minscale')) {
            attribute.minAttrPrec = datatype.minprec;
            attribute.minAttrScale = datatype.minscale;
        }

        if (objectWrapper.hasOwnProperty('designWrapper')) {
            //TODO
        }

        objectWrapper.doValidate();
    }

    up(selectedAttributes: Array<Attribute>, attributes: Array<Attribute>, objectWrapper: ObjectWrapper): Array<number> {
        let selectedAttr_Ids: Array<number> = new Array<number>();
        let selectedAttributesTmp: Array<Attribute> = new Array<Attribute>();

        for (let i: number = 0; i < selectedAttributes.length; i++) {
            let selectedAttribute: Attribute = selectedAttributes[i];
            selectedAttr_Ids.push(selectedAttribute.attr_Id);
            if (selectedAttribute.srt_Order == i) continue;

            selectedAttributesTmp.push(selectedAttribute);
        }
        if (selectedAttributesTmp.length == 0) return;

        for (let i: number = 0; i < selectedAttributesTmp.length; i++) {
            let selectedAttribute: Attribute = selectedAttributesTmp[i];
            let srt_Order: number = selectedAttribute.srt_Order;

            let deletedAttributes: Array<Attribute> = attributes.splice(srt_Order, 1);
            attributes.splice(srt_Order - 1, 0, deletedAttributes[0]);

            deletedAttributes[0].srt_Order--;
            attributes[srt_Order].srt_Order++;
        }

        ObjectUtil.getInstance().resetSrt_Order(attributes);

        return selectedAttr_Ids;
    }

    down(selectedAttributes: Array<Attribute>, attributes: Array<Attribute>, objectWrapper: ObjectWrapper): Array<number> {
        let selectedAttr_Ids: Array<number> = new Array<number>();
        let selectedAttributesTmp: Array<Attribute> = new Array<Attribute>();
        let index: number = 0;
        for (let i: number = selectedAttributes.length - 1; i >= 0; i--) {
            let selectedAttribute: Attribute = selectedAttributes[i];
            selectedAttr_Ids.push(selectedAttribute.attr_Id);

            index++;
            if (selectedAttribute.srt_Order == attributes.length - index) continue;

            selectedAttributesTmp.push(selectedAttribute);
        }
        if (selectedAttributesTmp.length == 0) return;

        for (let i: number = 0; i < selectedAttributesTmp.length; i++) {
            let selectedAttribute: Attribute = selectedAttributesTmp[i];
            let srt_Order: number = selectedAttribute.srt_Order;

            let deletedAttributes: Array<Attribute> = attributes.splice(srt_Order, 1);
            attributes.splice(srt_Order + 1, 0, deletedAttributes[0]);

            deletedAttributes[0].srt_Order++;
            attributes[srt_Order].srt_Order--;
        }

        return selectedAttr_Ids;
    }

    /**
     * 
     * @param copiedAttributes 
     * @param attributes 
     * @param attrType_Cd 
     * @param objectWrapper 
     * @param needRef_Id 
     * @param index 
     * 
     * 1) check copied attributes length is 0 then do return
     * 2) take 3 array variables which are pated attribute ids and pasted attributes temp and pasted attributes
     * 3) if objectwrapper(current wrapper) is dataobjectwrapper get copied objectwrapper also if not assign same objectwrapper as copied objectwrapper
     * 4) loop the copied attributes 
     *  i) check if needed refrence id set copied attribute ref_Id as copied attribute id
     *  ii) set attribute values like obj_Id, attri_Id, attr_Nm, attrDtyp_Id, and valid_Cd etc..
     *  iii) push them into pastedAttr_Ids and pastedattributestmp
     * 5) use  _insertAttributes() method to push in original attributes
     * 6) reset the attributes srt_Order
     * 7) return pasted attributes
     */
    paste(copiedAttributes: Array<Attribute>, attributes: Array<Attribute>, attrType_Cd: string, objectWrapper: ObjectWrapper,
        needRef_Id: boolean, index: number): Array<Attribute> {
        if (copiedAttributes.length == 0) return;

        let _pastedAttr_Ids: Array<number> = new Array<number>();
        let _pastedAttributesTmp: Array<Attribute> = new Array<Attribute>();
        let pastedAttributes: Array<Attribute> = new Array<Attribute>();

        let copiedObjectWrapper = objectWrapper;
        if (objectWrapper.obj_Cd == 'DOBJ' &&
            copiedAttributes[0].obj_Id != objectWrapper.obj_Id) {
            copiedObjectWrapper = Repository.getInstance().fldrObjectWrapper.objectWrappersMap.get(copiedAttributes[0].obj_Id);
        }
        if (!copiedObjectWrapper) return;

        for (let i = 0; i < copiedAttributes.length; i++) {
            let attributeTmp: Attribute = copiedAttributes[i].copy();

            if (needRef_Id) attributeTmp.ref_Id = attributeTmp.attr_Id;

            attributeTmp.obj_Id = objectWrapper.obj_Id;

            attributeTmp.attr_Id = this.objectWrapperUtil.getNewSub_Id(objectWrapper);
            attributeTmp.attrNm = this.util.getNewName(attributeTmp.attrNm, objectWrapper.subNames);

            if (objectWrapper.hasOwnProperty('designWrapper')) {
                attributeTmp.dxMp_Id = objectWrapper.designWrapper.obj_Id;
            }

            attributeTmp.attrDTyp_Id = this.databaseWrappersFactory.equivalentDbTyp_Id(copiedObjectWrapper.dbTyp_Id, attributeTmp.attrDTyp_Id, objectWrapper.dbTyp_Id);

            attributeTmp.valid_Cd = attrType_Cd == CommonEnums.attrType_Cd.DERIVED_ATTRIBUTE ? 'INVALID_COND' : attributeTmp.valid_Cd;

            attributeTmp.distKeyFlag = 0;
            attributeTmp.orgKeyFlag = 0;
            attributeTmp.orderBy = 0;

            attributeTmp.upiFlag = 0;
            attributeTmp.nupiFlag = 0;
            attributeTmp.usiFlag = 0;
            attributeTmp.nusiFlag = 0;

            this.objectWrapperUtil.addSubName(attributeTmp.attrNm.toUpperCase(), objectWrapper, attributeTmp.parent_Attr_Id.toString());
            this.objectWrapperUtil.addSub_Id(attributeTmp.attr_Id, attributeTmp, objectWrapper);

            _pastedAttributesTmp.push(attributeTmp);
            _pastedAttr_Ids.push(attributeTmp.attr_Id);
        }

        index = index == -1 ? attributes.length : index + 1;
        this._insertAttributes(attributes, index, _pastedAttributesTmp);
        for (let i = 0; i < attributes.length; i++) {
            let attributeTmp = attributes[i];

            attributeTmp.srt_Order = i;

            if (_pastedAttr_Ids.indexOf(attributeTmp.attr_Id) != -1) {
                pastedAttributes.push(attributeTmp);
            }
        }

        return pastedAttributes;
    }

    private _insertAttributes(arr, index, items) {
        let subarray = arr.slice.call(items);
        arr.splice.apply(arr, [index, 0].concat(subarray));
    }

    /**
     * @Params copied attributes, attributes, index, objectwrapper and attribute type code
     * 1) get clevel of selected attribute 
     * 2) call paste() method and get pasted attributes
     * 3) prepare ref_Ids Hash map using copiedattributes and get pasted attributes
     * 4) if any attribute is selected and then set parent attr_id this is we can mostly use in complex attributes
     */
    pasteAttributes(copiedAttributes: Array<Attribute>, attributes: Array<Attribute>, index: number, objectWrapper: ObjectWrapper,
        attrType_Cd: string): Array<Attribute> {
        if (copiedAttributes.length == 0) return;

        let attributeSelected = attributes[index];
        if (attributeSelected) {
            for (let i = 0; i < copiedAttributes.length; i++) {
                let copiedAttribute = copiedAttributes[i];
                copiedAttribute.clevel = attributeSelected.clevel;
            }
        }

        let pastedAttributes = this.paste(copiedAttributes, attributes, attrType_Cd, objectWrapper, true, index);
        if (!pastedAttributes) return pastedAttributes;

        let attributesPasted = [];
        let ref_Ids = [];
        let attributeTmp: Attribute;
        for (let i = 0; i < copiedAttributes.length; i++) {
            if (pastedAttributes[i].ref_Id != -1) {
                attributeTmp = pastedAttributes[i];
                attributesPasted.push(attributeTmp);
                ref_Ids[attributeTmp.ref_Id] = attributeTmp;
                attributeTmp.ref_Id = -1;
            }
        }

        let cLevels: Array<number> = this.business_glossaryUtil.getCLevels(attributes);

        if (attributeSelected) {
            for (let i = 0; i < attributesPasted.length; i++) {
                let attributePasted = attributesPasted[i];
                attributeTmp = ref_Ids[attributePasted.parent_Attr_Id];

                if (!attributeTmp) {
                    this.setParent_Attr_Id(attributePasted, attributeSelected.parent_Attr_Id, attributes, objectWrapper);
                    attributePasted.clevel = attributeSelected.clevel;
                } else {
                    this.setParent_Attr_Id(attributePasted, attributeTmp.attr_Id, attributes, objectWrapper);
                    attributePasted.clevel = this.business_glossaryUtil.getNextCLevelValue(attributeTmp.clevel, cLevels);
                }
            }
        }

        this.objectWrapperUtil.resetSrt_Order(attributes);
        return pastedAttributes;
    }

    setParent_Attr_Id(attribute: Attribute, parent_Attr_Id: number, attributes: Array<Attribute>, objectWrapper: ObjectWrapper): void {
        let attr_NmOld = this.getFullAttrNm(attribute, attributes, objectWrapper);

        attribute.parent_Attr_Id = parent_Attr_Id;

        let attr_NmNew = this.getFullAttrNm(attribute, attributes, objectWrapper);

        if (attr_NmOld == attr_NmNew) return;
    }

    pasteDerivedAttributes(index: number, copiedAttributes: Array<Attribute>, attributes: Array<Attribute>, objectWrapper: ObjectWrapper) {
        let copiedAttributesTmp: Array<Attribute> = this.clipboardCache.getCopiedItems();
        let copiedObjectWrapper: ObjectWrapper = Repository.getInstance().fldrObjectWrapper.objectWrappersMap.get(copiedAttributesTmp[0].dxMp_Id);
        if (!copiedObjectWrapper) {
            return 'No Derived Attribute(s) are copied to the clipboard';
        }

        if (objectWrapper.nativeDbTyp_Id != copiedObjectWrapper.nativeDbTyp_Id) {
            return "Copied Derived Attribute(s) are not allowed to paste for different types of objects";
        }
        this.pasteAttributes(copiedAttributesTmp, attributes, index, objectWrapper, undefined);
        if (this.clipboardCache.isCopied == false) {
            this.clipboardCache.reset();
        }
        return '';
    }
    getFullAttrNm(attribute: Attribute, attributes: Array<Attribute>, objectWrapper: ObjectWrapper, renamedAttrNm: string = '') {
        let attrNm = (renamedAttrNm == '' || !renamedAttrNm) ? attribute.attrNm : renamedAttrNm;

        if (objectWrapper.dbTyp_Id == DatabaseEnum.cobol.ID) return attrNm;
        if (objectWrapper.dbTyp_Id == DatabaseEnum.xsd.ID) return attrNm;

        if (attribute.parent_Attr_Id == -1 || attribute.parent_Attr_Id == -2) return attrNm;
        if (attributes.length == 0) return attrNm;

        let parent_Attr_Id = attribute.parent_Attr_Id;
        let attributeTmp: Attribute = new Attribute();
        for (let i = attribute.srt_Order - 1; i >= 0; i--) {
            attributeTmp = attributes[i];
            if (!attributeTmp) continue;

            if (attributeTmp.attr_Id == parent_Attr_Id) {
                attrNm = attributeTmp.attr_Id + '.' + attrNm;

                if (attributeTmp.parent_Attr_Id == -1 || attributeTmp.parent_Attr_Id == -2)
                    break;

                parent_Attr_Id = attributeTmp.parent_Attr_Id;
            }
        }

        return attrNm.toUpperCase();
    }

    setWarningForSrc_Attribute(attribute: any, transformWrapper: any) {
        let carryForwardAttribute = transformWrapper.carryForwardAttributeObjectsHMapIds.get(attribute.lnk_Obj_Id + '-' + attribute.lnk_Attr_Id);
        if (!carryForwardAttribute) return;

        attribute.valid_Cd = this.verifyFamily(attribute, carryForwardAttribute, transformWrapper) ? "0" : "-1";
    }

    verifyFamily(srcAttribute: Attribute, carryForwardAttribute: any, objectWrapper: ObjectWrapper) {

        let attribute = objectWrapper.sub_Ids.get(srcAttribute.attr_Id);//DIAttributesUtil.get( tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, targetWrapper.dataObjectWrapper.attributes );
        if (!attribute) return;

        let dbTyp_Id1 = objectWrapper.nativeDbTyp_Id == -2 ? objectWrapper.dbTyp_Id : objectWrapper.nativeDbTyp_Id; //objectWrapper.code == "OUTPUT" ? objectWrapper.dbTyp_Id : objectWrapper.dataObjectWrapper.dbTyp_Id;
        let attrDTyp_Id1 = srcAttribute.attrDTyp_Id;

        let dbTyp_Id2 = objectWrapper.dbTyp_Id; //objectWrapper.nativeDbTyp_Id;
        let attrDTyp_Id2 = carryForwardAttribute.attrDTyp_Id;

        let allowString: boolean = true;
        let intTolet: boolean = false;
        let isSameFamily: boolean = DatabaseWrappersFactory.getInstance().isSameFamily(dbTyp_Id1, attrDTyp_Id1, dbTyp_Id2, attrDTyp_Id2, allowString, intTolet);

        if (!isSameFamily)
            return isSameFamily;

        let dataTypeName1 = '';
        let dataType1 = DatabaseWrappersFactory.getInstance().getDatatype(dbTyp_Id1, attrDTyp_Id1);
        if (dataType1) dataTypeName1 = (dataType1.name).toLowerCase();

        let dataTypeName2 = '';
        let dataType2 = DatabaseWrappersFactory.getInstance().getDatatype(dbTyp_Id2, attrDTyp_Id2);
        if (dataType2) dataTypeName2 = (dataType2.name).toLowerCase();

        if (dataTypeName1 == dataTypeName2)
            return true;

        return false;
    }



    validateAttributeFamily(dbTyp_Id: number, attrDTyp_Id: number, dbTyp_Id2: number, attrDTyp_Id2, allowString: boolean = false, intToVar: boolean = false) {

        if (DatabaseWrappersFactory.getInstance().isSameFamily(dbTyp_Id, attrDTyp_Id, dbTyp_Id2, attrDTyp_Id2, allowString, intToVar)) return '0';

        return 'DIFF_TYPE';
    }



    getDownJumpCount(clevel: number, srt_Order: number, attributes: Array<Attribute>) {
        let jumpCount: number = 0;

        let attributeBelow: Attribute = attributes[srt_Order + 1];
        if (!attributeBelow) return jumpCount;

        if (clevel == attributeBelow.clevel) {
            let appendBelowAttributes = [];
            appendBelowAttributes.push(attributeBelow);

            this.business_glossaryUtil.appendChildAttributes(appendBelowAttributes, attributes);

            jumpCount = appendBelowAttributes.length;
        }

        return jumpCount;
    }

    setGroupDownSelectedAttributes(selectedAttributes: Array<Attribute>, attributes: Array<Attribute>) {
        let selectedAttributesGroups = [];

        let selectedAttributesGroup = null;
        let previousSrt_Order = -1;

        for (let i = 0; i < selectedAttributes.length; i++) {
            let selectedAttribute = selectedAttributes[i];

            if (previousSrt_Order == -1 ||
                selectedAttribute.srt_Order != previousSrt_Order + 1) {
                if (selectedAttributesGroup != null) {
                    let lastSelectedAttribute = selectedAttributesGroup.selectedAttributes[selectedAttributesGroup.selectedAttributes.length - 1];
                    selectedAttributesGroup.jumpCount = this.getDownJumpCount(selectedAttributesGroup.selectedAttributes[0].clevel,
                        lastSelectedAttribute.srt_Order, attributes);
                }

                selectedAttributesGroup = {};

                selectedAttributesGroups.push(selectedAttributesGroup);
                selectedAttributesGroup.selectedAttributes = [];
            }

            selectedAttributesGroup.selectedAttributes.push(selectedAttribute);
            previousSrt_Order = selectedAttribute.srt_Order;

            if (selectedAttributesGroup != null) {
                let lastSelectedAttribute = selectedAttributesGroup.selectedAttributes[selectedAttributesGroup.selectedAttributes.length - 1];
                selectedAttributesGroup.jumpCount = this.getDownJumpCount(selectedAttributesGroup.selectedAttributes[0].clevel,
                    lastSelectedAttribute.srt_Order, attributes);
            }

        }

        return selectedAttributesGroups;
    }

    promote(indices: Array<Attribute>, attributes: Array<Attribute>, objectWrapper: ObjectWrapper) {
        if (!indices || !attributes || !objectWrapper) return 'Argument are null';

        let cLevels: Array<number> = this.business_glossaryUtil.getCLevels(attributes);

        for (let i = 0; i < indices.length; i++) {
            let attribute = indices[i];
            this.doPromote(attribute, cLevels, attributes, objectWrapper);
        }

        this.objectWrapperUtil.resetSrt_Order(attributes);
    }

    doPromote(attribute: Attribute, cLevels: Array<number>, attributes: Array<Attribute>, objectWrapper: ObjectWrapper) {
        if (!attribute || !cLevels || !attributes) return;

        if (attribute.srt_Order == 0) return; // no promote for first attribute item
        if (attribute.clevel == cLevels[0]) return;

        let cLevelOld = attribute.clevel;
        let parent_Attr_IdOld = attribute.parent_Attr_Id;
        attribute.clevel = this.getPreviousCLevelValue(cLevelOld, cLevels);

        let i = 0;
        let attributeAbove = attributes[attribute.srt_Order - 1];
        if (attribute.clevel == attributeAbove.clevel) {
            this.setParent_Attr_Id(attribute, attributeAbove.parent_Attr_Id, attributes, objectWrapper);
            this.setDefaultAttrDTyp_IdValues(attributeAbove, objectWrapper);
        } else {
            let attributeAboveSameCLevel = this.getAboveAttributeOfSameCLevel(attribute, attributes);
            if (attributeAboveSameCLevel)
                this.setParent_Attr_Id(attribute, attributeAboveSameCLevel.parent_Attr_Id, attributes, objectWrapper);
        }

        this.business_glossaryUtil.setAttributeReadOnlyProperties(attribute, objectWrapper);

        if (attribute.srt_Order >= attributes.length - 1) return;

        let attributebelow = attributes[attribute.srt_Order + 1];
        let attributeTmp;
        if (cLevelOld == attributebelow.clevel) {
            this.setParent_Attr_Id(attributebelow, attribute.attr_Id, attributes, objectWrapper);
            this.setEmptyAttrDTyp_IdValues(attribute);

            for (i = attributebelow.srt_Order + 1; i < attributes.length; i++) {
                attributeTmp = attributes[i];
                if (attributeTmp.clevel < cLevelOld) break;

                if (attributeTmp.parent_Attr_Id == parent_Attr_IdOld) {
                    this.setParent_Attr_Id(attributeTmp, attribute.attr_Id, attributes, objectWrapper);
                }
            }
        } else if (cLevelOld < attributebelow.clevel) { // Pull 
            attributebelow.clevel = cLevelOld;

            for (i = attributebelow.srt_Order + 1; i < attributes.length; i++) {
                attributeTmp = attributes[i];
                if (attributeTmp.clevel <= cLevelOld) break;

                for (let j = 0; j < cLevels.length; j++) {
                    if (attributeTmp.clevel == cLevels[j]) {
                        attributeTmp.clevel = cLevels[j - 1];
                        break;
                    }
                }
            }
        }
    }

    getPreviousCLevelValue(cLevel: number, cLevels: Array<number>): number {
        for (let i = 0; i < cLevels.length; i++) {
            if (cLevel == cLevels[i])
                return cLevels[i - 1];
        }

        return cLevel - CommonEnums.defaults.CLEVEL;
    }

    //Demote
    demote(indices: Array<Attribute>, attributes: Array<Attribute>, objectWrapper: ObjectWrapper) {
        if (!indices || !attributes || !objectWrapper) return 'Argument are null';

        let cLevels = this.business_glossaryUtil.getCLevels(attributes); // get change levels
        for (let i = 0; i < indices.length; i++) {
            let attribute = indices[i];
            this.doDemote(attribute, cLevels, attributes, objectWrapper);
        }

        this.objectWrapperUtil.resetSrt_Order(attributes);
    }

    doDemote(attribute: Attribute, cLevels: Array<number>, attributes: Array<Attribute>, objectWrapper: ObjectWrapper) {
        if (!attribute || !cLevels || !attributes) return;
        if (attribute.srt_Order == 0) return; // rule 1: no demote for first attribute item

        let attributeAbove = attributes[attribute.srt_Order - 1];
        if (attribute.clevel > attributeAbove.clevel) return; // rule 2: attribute clevel must and should be less than or equal to above attribute 

        let cLevelOld = attribute.clevel;
        let parent_Attr_IdOld = attribute.parent_Attr_Id;

        attribute.clevel = this.business_glossaryUtil.getNextCLevelValue(attribute.clevel, cLevels);

        let i = 0;
        // rule 3: add parent_attr_Id to selected attribute
        if (attribute.clevel == attributeAbove.clevel) {
            // attribute.clevel == attributeAbove.clevel both are equal then about attribute parent_Attr_Id is same for present selected attribute
            this.setParent_Attr_Id(attribute, attributeAbove.parent_Attr_Id, attributes, objectWrapper);
        } else if (attribute.clevel > attributeAbove.clevel) {
            this.setParent_Attr_Id(attribute, attributeAbove.attr_Id, attributes, objectWrapper);
            this.setEmptyAttrDTyp_IdValues(attributeAbove); // rule 4: empty above attribute AttrDTyp_Id Values
        } else {
            let attributeAboveSameCLevel = this.getAboveAttributeOfSameCLevel(attribute, attributes);
            if (attributeAboveSameCLevel) {
                this.setParent_Attr_Id(attribute, attributeAboveSameCLevel.parent_Attr_Id, attributes, objectWrapper);
            }
        }
        this.business_glossaryUtil.setAttributeReadOnlyProperties(attribute, objectWrapper);

        if (attribute.srt_Order >= attributes.length - 1) return;

        let attributeBelow = attributes[attribute.srt_Order + 1];
        if (attributeBelow.clevel == attribute.clevel) {
            this.setParent_Attr_Id(attributeBelow, attribute.parent_Attr_Id, attributes, objectWrapper);
            this.setDefaultAttrDTyp_IdValues(attribute, objectWrapper);

            for (i = attributeBelow.srt_Order + 1; i < attributes.length; i++) {
                let attributeTmp = attributes[i];
                if (attributeTmp.clevel < cLevelOld) break;

                if (attributeTmp.parent_Attr_Id == parent_Attr_IdOld) {
                    this.setParent_Attr_Id(attributeTmp, attribute.parent_Attr_Id, attributes, objectWrapper);
                }
            }
        }
    }

    getAboveAttributeOfSameCLevel(attribute: Attribute, attributes: Array<Attribute>) {
        let attributeTmp = new Attribute();

        for (let i = attribute.srt_Order - 1; i >= 0; i--) {
            attributeTmp = attributes[i];

            if (attributeTmp.clevel == attribute.clevel)
                return attributeTmp;

            if (attributeTmp.clevel < attribute.clevel)
                break;
        }

        return
    }


    setDefaultAttrDTyp_IdValues(attribute: Attribute, objectWrapper: ObjectWrapper) {
        let datatype; // = DIDatabases.getDefaultDatatype(objectWrapper.nativeDbTyp_Id);
        if (datatype) {
            attribute.attrDTyp_Id = datatype.id;
            attribute.attrPrec = datatype.defaultprecision;
            attribute.attrScale = datatype.defaultscale;
        }
    }

    setEmptyAttrDTyp_IdValues(attribute: Attribute) {
        attribute.attrDTyp_Id = 0;
        attribute.attrPrec = 0;
        attribute.attrScale = 0;
        attribute.attrDTypNm = '';
    }

    isParent(attribute: Attribute, attributes: Array<Attribute>) {
        if (attributes.length <= attribute.srt_Order + 1) return false;

        let attributeNext = attributes[attribute.srt_Order + 1];
        if (!attributeNext) return false;

        if (attributeNext.parent_Attr_Id != attribute.attr_Id) return false;

        return true;
    }


    hasChildElements(attribute: Attribute, attributes: Array<Attribute>) {
        if (attribute.attrType_Cd != CommonEnums.attrType_Cd.ELEMENT) return false;

        for (let i = attribute.srt_Order + 1; i < attributes.length; i++) {
            if (attributes[i].clevel <= attribute.clevel)
                break;

            if (attributes[i].attrType_Cd == CommonEnums.attrType_Cd.ELEMENT)
                return true;
        }

        return false;
    }

    getAttribute(attr_Id: number, attributes: Array<Attribute>) {
        for (let i = 0; i < attributes.length; i++) {
            let attribute = attributes[i];
            if (attribute.attr_Id == attr_Id)
                return attribute;
        }

        return null;
    }

    getInsertAtIndex(attribute: Attribute, attributes: Array<Attribute>, objectWrapper: ObjectWrapper) {
        if (!attribute || !attributes) return 0;

        let insertAtIndex = attribute.srt_Order + 1;

        let parent_Attr_Ids = [];
        parent_Attr_Ids.push(attribute.attr_Id);

        return insertAtIndex;
    }

    getInsertAtPosition(selectedAttributes: Array<Attribute>, attributes: Array<Attribute>, objectWrapper: ObjectWrapper) {
        if (selectedAttributes.length == 0) return { 'insertAtPosition': attributes.length, 'selectedAttribute': null };


        return { 'insertAtPosition': attributes.length, 'selectedAttribute': null };
    }

    getInsertPostion(selectedAttributes: Array<Attribute>, attributes: Array<Attribute>) {
        this.business_glossaryUtil.appendChildAttributes(selectedAttributes, attributes);

        let lastSelectedAttribute = selectedAttributes[selectedAttributes.length - 1];

        return lastSelectedAttribute.srt_Order + 1;
    }

    getInsertAtComplexPosition(selectedAttribute: Attribute, attributes: Array<Attribute>, objectWrapper: ObjectWrapper) {
        do {
            if (selectedAttribute.parent_Attr_Id == -1) break;

            let parentAttribute = objectWrapper.sub_Ids.get(selectedAttribute.parent_Attr_Id);
            if (!parentAttribute) break;

            let datatype;
            if (!datatype) break;

            if (datatype.allowAdditional == 'Y') break;

            selectedAttribute = parentAttribute;
        } while (1);
        let attr_Ids = [];
        attr_Ids.push(selectedAttribute.attr_Id);

        for (let i = selectedAttribute.srt_Order + 1; i < attributes.length; i++) {
            let attribute = attributes[i];

            if (attribute.parent_Attr_Id == -1) return { 'insertAtPosition': i, 'selectedAttribute': selectedAttribute };
            if (attr_Ids.indexOf(attribute.parent_Attr_Id) == -1) return { 'insertAtPosition': i, 'selectedAttribute': selectedAttribute };
            if (attr_Ids.indexOf(attribute.attr_Id) != -1) continue;

            attr_Ids.push(attribute.attr_Id);
        }

        return { 'insertAtPosition': attributes.length, 'selectedAttribute': null };
    }

    getParentIds(attributes: Array<Attribute>) {
        let parentIds: Array<number> = new Array<number>();

        for (let i = 0; i < attributes.length; i++) {
            let attribute = attributes[i];
            if (parentIds.indexOf(attribute.parent_Attr_Id) != -1) continue;
            if (attribute.parent_Attr_Id == -1) continue;
            parentIds.push(attribute.parent_Attr_Id);
        }

        return parentIds;
    }

    getParentAttribute(attribute: Attribute, attributes: Array<Attribute>) {
        let parentAttribute = attribute;

        for (let i = 0; i < attributes.length; i++) {
            let attribute1 = attributes[i];
            if (attribute1.attr_Id == attribute.parent_Attr_Id) {
                if (attribute1.parent_Attr_Id != -1) {
                    return this.getParentAttribute(attribute1, attributes);
                } else
                    return attribute1;
            }
        }
        return parentAttribute;
    }

    getImmediateParentAttribute(selectedAttribute: Attribute, attributes: Array<Attribute>) {
        for (let i = 0; i < attributes.length; i++) {
            let attribute = attributes[i];
            if (attribute.attr_Id != selectedAttribute.parent_Attr_Id) continue;
            return attribute;
        }
    }

    addSourceLinkAttributes(attributes: Array<Attribute>, transformWrapper: ObjectWrapper, carryForwardAttributes: Array<CarryForwardAttribute>) {
        let lnk_Attr_IdsMap: Map<string, any> = new Map<string, any>();
        let subNamesMap: Map<string, any> = new Map<string, any>();

        for (let i: number = 0; i < attributes.length; i++) {
            let linkAttribute: Attribute = attributes[i];

            if (linkAttribute.lnk_Attr_Id == -1) {
                subNamesMap.set(linkAttribute.attrNm, linkAttribute);
            } else {
                lnk_Attr_IdsMap.set(linkAttribute.lnk_Obj_Id + '-' + linkAttribute.lnk_Attr_Id, linkAttribute);
            }
        }

        let _nativeDbTyp_Id: number = transformWrapper.nativeDbTyp_Id == -2 ? transformWrapper.dbTyp_Id : transformWrapper.nativeDbTyp_Id;

        for (let i: number = 0; i < carryForwardAttributes.length; i++) {
            let transformObject: any = carryForwardAttributes[i];

            for (let j: number = 0; j < transformObject.items.length; j++) {
                let attributeObject: any = transformObject.items[j];

                if (attributeObject.checked) {
                    if (lnk_Attr_IdsMap.get(transformObject.obj_Id + '-' + attributeObject.attr_Id)) continue;

                    let attribute: any = subNamesMap.get(attributeObject.text);
                    if (typeof (attribute) != "object" || !attribute) {
                        attribute = new Attribute;

                        attribute.dxMp_Id = transformWrapper.dxMp_Id;
                        attribute.obj_Id = transformWrapper.obj_Id;
                        attribute.attr_Id = this.objectWrapperUtil.getNewSub_Id(transformWrapper);
                        attribute.attrNm = Util.getInstance().getNewName(attributeObject.text, transformWrapper.subNames);

                        attribute.attrDTyp_Id = this.databaseWrappersFactory.equivalentDbTyp_Id(transformObject.dbTyp_Id, attributeObject.attrDTyp_Id, _nativeDbTyp_Id);

                        let attrPrec = attributeObject.attrPrec;
                        let dataType = this.databaseWrappersFactory.getDatatype(transformObject.dbTyp_Id, attributeObject.attrDTyp_Id)

                        /*** 
                         * In source attributes, Deletion and adding of link attributes prec is missing 
                         * While adding link attributes prec is changing here depends on type of datatype 
                         * if 'isText == 'y'' is for changing string to letchar.. for letchar '2000'
                         * transformObject.dbTyp_Id == '5' is for Db2 source for datatypes 'char' prec is 254 and decimal is 31
                        ***/

                        if (dataType.hasOwnProperty('isText') &&
                            (dataType.isText == 'Y' || dataType.isText == 'y')) {
                            attrPrec = 2000;
                        } else if (transformObject.dbTyp_Id == 5) {
                            if (dataType.id == 1) {
                                attrPrec = 254;
                            } else if (dataType.id == 3) {
                                attrPrec = 31;
                            }
                        }

                        if (_nativeDbTyp_Id == 1) {
                            if (attribute.attrDTyp_Id == 93)
                                attrPrec = 6;
                        }

                        if ((transformWrapper.dbTyp_Id == 7 || transformWrapper.dbTyp_Id == 3)) {
                            if (dataType.id == -7)
                                attrPrec = 5;
                        }

                        if (_nativeDbTyp_Id == 7 &&
                            attributeObject.attrPrec > 8000) {
                            if (attribute.attrDTyp_Id == 1 ||
                                attribute.attrDTyp_Id == 12) {
                                attrPrec = 8000;
                            }
                        }

                        if (_nativeDbTyp_Id == 5 &&
                            attributeObject.attrPrec > 31) {

                            if (attribute.attrDTyp_Id == 3 ||
                                attribute.attrDTyp_Id == 2) {
                                attrPrec = 31;
                            }
                        }

                        if (_nativeDbTyp_Id == 11 &&
                            attribute.attrDTyp_Id == -5 &&
                            transformWrapper.dbTyp_Id == 3) {
                            attrPrec = 19;
                        }

                        attribute.attrPrec = attrPrec;
                        attribute.attrScale = attributeObject.attrScale;

                        attribute.srt_Order = attributes.length;

                        attribute.lnk_Obj_Id = transformObject.obj_Id;
                        attribute.lnk_Attr_Id = attributeObject.attr_Id;

                        attribute.valid_Cd = '0';
                        attribute.error_Msg = '';

                        this.business_glossaryUtil.setAttributeReadOnlyProperties(attribute, transformWrapper);

                        attributes.push(attribute);
                        transformWrapper.subNames.push((attribute.attrNm).toUpperCase());
                        this.objectWrapperUtil.addSub_Id(attribute.attr_Id, attribute, transformWrapper);

                    } else {
                        attribute.lnk_Obj_Id = transformObject.obj_Id;
                        attribute.lnk_Attr_Id = attributeObject.attr_Id;

                        attribute.valid_Cd = '0';
                        attribute.error_Msg = '';

                        this.business_glossaryUtil.setAttributeReadOnlyProperties(attribute, transformWrapper);
                    }
                } else {
                    let attribute: Attribute = lnk_Attr_IdsMap.get(transformObject.obj_Id + '-' + attributeObject.attr_Id);
                    if (!attribute) continue;

                    attribute.lnk_Obj_Id = -1;
                    attribute.lnk_Attr_Id = -1;

                    attribute.valid_Cd = "NO_ATTR_LNK";
                    attribute.error_Msg = this.objectWrapperUtil.getError_Msg(attribute.valid_Cd);

                    this.business_glossaryUtil.setAttributeReadOnlyProperties(attribute, transformWrapper);
                }
            }
        }
    }

    attrNmBlur(attribute: Attribute, oldAttrNm: string, objectWrapper, srt_Order: number) {
        let objectWrapperUtil = ObjectWrapperUtil.getInstance();


        if (attribute.attrNm == "") {
            attribute.attrNm = oldAttrNm;
            return attribute.attrNm;
        }
        try {
            new RegExp('\\b' +  attribute.attrNm + '\\b', 'g');
        } catch (e) {
            attribute.attrNm = oldAttrNm;
            return attribute.attrNm;
        }

        let parentAttribute = objectWrapper.sub_Ids.get(attribute.parent_Attr_Id);
        if (parentAttribute && parentAttribute.attrDTyp_Id == 11) {
            attribute.attrNm = oldAttrNm;

            return attribute.attrNm;
        }

        if (objectWrapper.dataObject &&
            objectWrapper.dataObject.dObj.caseSensitiveFlg != 'Y' &&
            objectWrapper.dataObject.dObj.dbTyp_Id != 40 &&
            objectWrapperUtil.hasWhiteSpace(attribute.attrNm)) {
            attribute.attrNm = oldAttrNm;

            return attribute.attrNm;
        } else if (!objectWrapper.dataObject &&
            objectWrapperUtil.isAttributeNameValidate(attribute.attrNm)) {
            attribute.attrNm = oldAttrNm;

            return attribute.attrNm;
        }

        let parent_Attr_Id = attribute.parent_Attr_Id != -1 ? attribute.parent_Attr_Id : '';
        let attrNmUC = parent_Attr_Id + attribute.attrNm.toUpperCase();
        let oldAttrNmUC = oldAttrNm.toUpperCase();
        if (oldAttrNmUC == attrNmUC) {

            return attribute.attrNm;
        }

        let index = objectWrapper.subNames.indexOf(attrNmUC);
        if (index != -1) {
            attribute.attrNm = oldAttrNm;
            return attribute.attrNm;
        }

        index = objectWrapper.subNames.indexOf(oldAttrNmUC);
        if (index != -1) objectWrapper.subNames.splice(index, 1, attrNmUC);

        // transforms
        if (objectWrapper.hasOwnProperty('designWrapper')) {
            let oldFullName = objectWrapper.name + '.' + oldAttrNm;
            let newFullName = objectWrapper.name + '.' + attribute.attrNm;
          
            TransformsUtil.getInstance().downStreamRename(oldAttrNm, attribute.attrNm, oldFullName, newFullName, srt_Order, attribute.attr_Id, objectWrapper, objectWrapper.designWrapper);
        } else if (objectWrapper.hasOwnProperty('dBFun')) {
            let oldFullName = objectWrapper.name + '.' + oldAttrNm;
            let newFullName = objectWrapper.name + '.' + attribute.attrNm;
            objectWrapper.renameAttributes(oldFullName, newFullName);//TODO
        }
        objectWrapper.doValidate();
        return attribute.attrNm;

    }

    /**
     * @description getPreviousAttrNmAsItalic()
     * @author <muppu> <Jira Id-DDS-9811>
     * @param selectedTabCode 
     * @param attributes 
     * @param carryForwardAttributes 
     * @usageNotes
     * getPreviousAttrNmAsItalic() method invokes when we open add carryforward popup/select attributes popup.
     * if we open carryforward popup if not attributes are not present in attributes grid list it will return.
     * if we add attribtes and click select attributes popup
     * here we are checking `selectedTabCode` param if tab codes 
     * #### 'ATTR' ,'DATTR'
     * if tabcodes are 'ATTR','DATTR' will prepare a attrNmsHMap based on `attribute.attrExprVal` and `attribute.attrNm `.
     * if tab code are not wqual to 'ATTR','DATTR' consider as a `Lattribute`.
     * #### 'objIds
     * in Lattribute checking as  `attribute.lnk_Obj_Inst_Id`
     * @returns  
     */
    getPreviousAttrNmAsItalic(selectedTabCode: string, attributes: Array<any>, carryForwardAttributes: Array<any>) {

        if (attributes.length == 0) return;
        let attrNmsHMap = new Map<string, string>();
        let objIds = new Array<any>();

        if (selectedTabCode == 'ATTR' || selectedTabCode == 'DATTR') {
            for (let i = 0; i < attributes.length; i++) {
                let attribute = attributes[i];
                let found = this.objectWrapperUtil.hasWhiteSpace(attribute.attrExprVal);
                if (found) {
                    let name = attribute.attrExprVal.replace(/\s/g, '');
                    attrNmsHMap.set(name, attribute.attrNm);
                } else {
                    attrNmsHMap.set(attribute.attrExprVal, attribute.attrNm);
                }
            }
            for (let j = 0; j < carryForwardAttributes.length; j++) {
                for (let k = 0; k < carryForwardAttributes[j].items.length; k++) {
                    let item = carryForwardAttributes[j].items[k];
                    item.isFontChange = false;
                    if (!attrNmsHMap.get(item.name)) continue;
                    item.isFontChange = true;
                }
            }
        } else {
            for (let i = 0; i < attributes.length; i++) {
                let attribute = attributes[i];
                objIds.push(attribute.lnk_Obj_Inst_Id);
            }

            for (let j = 0; j < carryForwardAttributes.length; j++) {
                let carryForwardAttribute = carryForwardAttributes[j];
                for (let k = 0; k < objIds.length; k++) {
                    if (objIds[k] != carryForwardAttributes[j].obj_Id) continue;
                    for (let l = 0; l < carryForwardAttribute.items.length; l++) {
                        let item = carryForwardAttribute.items[l];
                        item.isFontChange = false;
                        if (item.checked != true) continue;
                        item.isFontChange = true;
                    }
                }
            }
        }
    }

    addCarryForwardAttributes(transformWrapper, attributes: Array<Attribute>, carryForwardAttributes: Array<any>): Array<number> {
        let isPerformance = transformWrapper.hasOwnProperty('designWrapper') || transformWrapper.hasOwnProperty('design');
        let attributeIds: Array<number> = new Array<number>();

        let lnk_Attr_Ids: Map<any, any> = new Map<any, any>();
        let subNames: Map<any, any> = new Map<any, any>();

        for (let i: number = 0; i < attributes.length; i++) {
            let linkAttribute = attributes[i];

            if (linkAttribute.lnk_Attr_Id == -1) {
                subNames.set(linkAttribute.attrNm, linkAttribute);
            } else {
                lnk_Attr_Ids.set(linkAttribute.lnk_Obj_Id + '-' + linkAttribute.lnk_Attr_Id, linkAttribute);
            }
        }

        for (let i: number = 0; i < carryForwardAttributes.length; i++) {
            let transformObject: any = carryForwardAttributes[i]

            for (let j: number = 0; j < transformObject.items.length; j++) {
                let attributeObject: any = transformObject.items[j];
                if (attributeObject.selected) {
                    // if (selectedObj_Ids.indexOf(attributeObject.obj_Id + '-' + attributeObject.attr_Id) == -1) continue;
                    if (lnk_Attr_Ids.get(transformObject.obj_Id + '-' + attributeObject.attr_Id)) continue;

                    var attribute = subNames.get(attributeObject.text);
                    if (typeof (attribute) != "object" || !attribute) {
                        let attributeNew = new Attribute();

                        if (attributeObject.attrDTyp_Id == DatabaseEnum.databaseId.EXADATA) {
                            let childAttribute = this.objectWrapperUtil.getImmideateChildAttribute(attributeObject, transformObject.items, transformObject, transformWrapper)
                            if (childAttribute && childAttribute.attrDTyp_Id == DatabaseEnum.databaseId.PARQUET && attributeObject.explodeFlag == 'Y')
                                continue;
                        } else if (attributeObject.attrDTyp_Id == DatabaseEnum.databaseId.JMS &&
                            attributeObject.explodeFlag == 'Y') {
                            continue;
                        }
                        //  else if (attributeObject.parentAttribute &&
                        //     attributeObject.parentAttribute.attrDTyp_Id == DatabaseEnum.databaseId.JMS &&
                        //     attributeObject.parentAttribute.explodeFlag == 'N') {
                        //     continue;
                        // }

                        if (transformWrapper.obj_Cd == 'DOBJIS' &&
                            transformWrapper.dbTyp_Id == DatabaseEnum.databaseId.BIGQUERY && attributeObject.attrDTyp_Id == DatabaseEnum.databaseId.PARQUET) {
                            continue;
                        }

                        if (!attributeObject.showUnderline && !isPerformance)
                            continue;

                        attributeNew.obj_Id = transformWrapper.obj_Id;
                        attributeNew.dxMp_Id = transformWrapper.designWrapper.obj_Id;

                        attributeNew.attr_Id = this.objectWrapperUtil.getNewSub_Id(transformWrapper);
                        attributeNew.attrNm = this.util.getNewName(attributeObject.text, transformWrapper.subNames);

                        if (transformObject.obj_Cd == 'DOBJ' &&
                            transformObject.dbTyp_Id != transformWrapper.nativeDbTyp_Id) {
                            attributeNew.attrDTyp_Id = this.databaseWrappersFactory.equivalentDbTyp_Id(transformObject.dbTyp_Id, attributeObject.attrDTyp_Id, transformWrapper.nativeDbTyp_Id);
                        } else {
                            attributeNew.attrDTyp_Id = attributeObject.attrDTyp_Id;
                        }

                        let datatype: Datatype;
                        if (transformWrapper.obj_Cd == 'DOBJIS' &&
                            transformWrapper.nativeDbTyp_Id != transformObject.dbTyp_Id) {
                            // check
                            datatype = this.databaseWrappersFactory.getEqDataType(transformWrapper.nativeDbTyp_Id, transformObject.dbTyp_Id, attributeNew.attrDTyp_Id, transformWrapper.designWrapper.databaseWrapper);
                            if (!datatype) return;

                            attributeNew.attrDTyp_Id = datatype.id;
                        } else {
                            let dbTyp_Id = transformWrapper.nativeDbTyp_Id == DatabaseEnum.databaseId.GENERIC || transformWrapper.nativeDbTyp_Id == DatabaseEnum.databaseId.DATAMASKING ? transformObject.dbTyp_Id : transformWrapper.nativeDbTyp_Id;
                            datatype = this.databaseWrappersFactory.getDatatype(dbTyp_Id, attributeNew.attrDTyp_Id);
                            if (!datatype) return;
                        }

                        attributeNew.attrPrec = attributeObject.attrPrec;
                        attributeNew.attrScale = attributeObject.attrScale;
                        attributeNew.maxFlag = attributeObject.maxFlag;
                        attributeNew.lnk_Obj_Id = attributeObject.obj_Id;
                        attributeNew.lnk_Attr_Id = attributeObject.attr_Id;
                        attributeNew.partitionflag = attributeObject.partitionflag;

                        if (datatype.enableprecision == 'y' &&
                            attributeNew.attrPrec == 0 && attributeNew.maxFlag == 'N')
                            attributeNew.attrPrec = datatype.defaultprecision;

                        if (datatype.enablescale == 'y' &&
                            attributeNew.attrScale == 0 &&
                            attributeNew.attrPrec > datatype.defaultscale)
                            attributeNew.attrScale = datatype.defaultscale;

                        if (transformWrapper.dbTyp_Id == DatabaseEnum.databaseId.MSSQL) { // setting attrScale as carry forward  attrScale value for mssql (DDS-7978 )
                            attributeNew.attrScale = attributeObject.attrScale;
                        }

                        if (transformWrapper.obj_Cd == CommonEnums.codes.TRANSPOSE_CODE) {
                            attributeNew.isEditable = CommonEnums.flag.NO;
                        }

                        attributeNew.attrExprVal = attributeObject.name;
                        attributeNew.fldValue = attributeObject.name;
                        attributeNew.valid_Cd = '0';

                        attributeNew.attrType_Cd = CommonEnums.attrType_Cd.DERIVED_ATTRIBUTE;

                        this.business_glossaryUtil.setAttributeReadOnlyProperties(attributeNew, transformWrapper, false);

                        if (transformWrapper.obj_Cd == 'DOBJIT') {
                            attributeNew.lnk_Obj_Id = transformObject.obj_Id;
                            attributeNew.lnk_Attr_Id = attributeObject.attr_Id;
                        }

                        this.business_glossaryUtil.insert(attributeNew, attributes, transformWrapper);
                        attributeIds.push(attributeNew.attr_Id);
                    } else {
                        attribute.lnk_Obj_Id = transformObject.obj_Id;
                        attribute.lnk_Attr_Id = attributeObject.attr_Id;

                        attribute.valid_Cd = '0';
                        attribute.error_Msg = '';

                        Business_GlossaryUtil.getInstance().setAttributeReadOnlyProperties(attribute, transformWrapper);
                    }
                } else {
                    let attribute1 = lnk_Attr_Ids.get(transformObject.obj_Id + '-' + attributeObject.attr_Id);
                    if (!attribute1) continue;
                    if (attribute1.valid_Cd == '0') continue;
                    if (transformWrapper.obj_Cd != CommonEnums.codes.MASKING) {
                        attribute1.lnk_Obj_Id = -1;
                        attribute1.lnk_Attr_Id = -1;

                        attribute1.valid_Cd = "NO_ATTR_LNK";
                        attribute1.error_Msg = ObjectWrapperUtil.getInstance().getError_Msg(attribute1.valid_Cd);

                        Business_GlossaryUtil.getInstance().setAttributeReadOnlyProperties(attribute1, transformWrapper);
                    }
                }

            }
        }
        return attributeIds;
    }
}